import React from 'react';
import PropTypes from 'prop-types';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';

import DataTable from '../../components/DataTable/DataTable';


const currentYear = moment().format('YYYY');

function TabPanel(props) {
  const {
    children,
    value,
    index,
    ...other
  } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </Typography>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function table(content, value) {
  let payments = [];

  if (content && content.length) {
    payments = [...content];

    if (value === 1) {
      payments = (payments.filter(payment => moment(payment.date, 'dd/MM/YYYY').format('YYYY') === currentYear));
    } else {
      payments = content;
    }
  }

  if (payments && payments.length) {
    return payments.map(payment => ({
      plan: `${payment.name} (R$${payment.price.toFixed(2).replace('.', ',')}) ${payment.daysOffers > 30 ? '- Anual' : '- Mensal'}`,
      date: payment.date,
    }));
  }

  return [];
}

function SubscriptionHistory({ payments }) {
  const [value, setValue] = React.useState(0);
  const panels = [0, 1];
  const columns = [
    { name: 'plan', label: 'Plano' },
    { name: 'date', label: 'Data', align: 'center', styles: { width: '200px' } }
  ];

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div style={{ paddingTop: '30px', paddingBottom: '30px' }}>
      <div style={{ display: 'flex', alignItems: 'baseline' }}>
        <Typography variant="h6" >Histórico de Pagamentos</Typography>
        <Tabs
          value={value}
          indicatorColor="primary"
          onChange={handleChange}
          aria-label="simple
          tabs
          example"
          style={{ marginLeft: 'auto' }}
        >
          <Tab
            label={<Typography variant="body1" style={{ textTransform: 'capitalize' }}>Todos</Typography>}
            {...a11yProps(0)}
          />
          <Tab
            label={
              <Typography variant="body1" style={{ textTransform: 'capitalize' }}>Este ano</Typography>
            }
            {...a11yProps(1)}
          />
        </Tabs>
      </div>

      {
        panels.map(panel => (
          <TabPanel value={value} index={panel}>
            <Paper elevation={2}>
              <DataTable rows={table(payments, value)} columns={columns} noResultsText="Nenhuma informação disponível" />
            </Paper>
          </TabPanel>
        ))
      }
    </div>
  );
}

SubscriptionHistory.propTypes = {
  payments: PropTypes.array.isRequired,
};

export default SubscriptionHistory;
